export default {
  title: 'اشتراک ها',

  table: {
    header: {
      row: 'ردیف',
      app: 'اپلیکیشن',
      expiredAt: 'تاریخ انقضاء',
      activeAt: 'تاریخ فعالسازی',
      price: 'قیمت',
      status: 'وضعیت',
      renewable: 'تمدید خودکار'
    }
  },

  labels: {
    priceDifference: 'نیاز به پرداخت'
  },

  statusTypes: {
    active: 'فعال',
    pending: 'درانتظار',
    expired: 'انقضاء شده',
    canceled: 'لغو شده',
  },

  notifications: {
    planDisabled: 'پلن غیرفعال است',
    planRenewableDisabled: 'تمدید خودکار پلن غیرفعال است',
    appDisabled: 'اپلیکیشن غیرفعال است',
    renewableActive: 'تمدید خودکار اشتراک فعال است',
    addonRenewableActive: 'تمدید خودکار افزودنی اشتراک فعال است',
    addonDisabled: 'افزودنی غیرفعال است',
    incorrectAppStatus: 'وضعیت اپلیکیشن معتبر نیست',
    notActive: 'اشتراک غیرفعال است',
    appExpirySoon: 'اپلیکیشن به زودی منقضی میشود',
    noChange: 'تغییری داده نشده است',
    incorrectType: 'نوع اشتراک معتبر نیست',
    incorrectStatus: 'وضعیت اشتراک معتبر نیست',
    cantAddAddon: 'نمیتوان افزودنی اضافه کرد',

    insert: {
      success: 'اشتراک اپلیکیشن با موفقیت ایجاد شد',
      error: 'افزودن اشتراک اپلیکیشن با خطا همراه شد'
    },
    edit: {
      success: 'اشتراک اپلیکیشن با موفقیت بروزرسانی شد',
      error: 'بروزرسانی اشتراک اپلیکیشن با خطا همراه شد'
    },
    delete: {
      success: 'اشتراک اپلیکیشن با موفقیت حذف شد',
      error: 'حذف اشتراک اپلیکیشن با خطا همراه شد'
    },
    reactive: {
      success: 'اشتراک اپلیکیشن با موفقیت فعال شد',
      error: 'فعال شدن اشتراک اپلیکیشن با خطا همراه شد'
    },
    cancel: {
      success: 'اشتراک اپلیکیشن با موفقیت لغو شد',
      error: 'لغو شدن اشتراک اپلیکیشن با خطا همراه شد'
    },
    deleteAddon: {
      success: 'افزودنی اشتراک با موفقیت حذف شد',
      error: 'حذف افزودنی اشتراک با خطا همراه شد'
    },
    renew: {
      success: 'اشتراک اپلیکیشن با موفقیت تمدید شد',
      error: 'تمدید اشتراک اپلیکیشن با خطا همراه شد'
    },
    renewAddon: {
      success: 'افزودنی اشتراک با موفقیت تمدید شد',
      error: 'تمدید افزودنی اشتراک با خطا همراه شد'
    }
  },

  confirmations: {
    delete: {
      title: 'تاییدیه حذف اشتراک اپلیکیشن',
      body: 'آیا از حذف اشتراک اپلیکیشن اطمینان دارید؟'
    },
    reactive: {
      title: 'تاییدیه فعال کردن مجدد اشتراک اپلیکیشن',
      body: 'آیا از فعال کردن مجدد اشتراک اپلیکیشن اطمینان دارید؟'
    },
    cancel: {
      title: 'تاییدیه لغو اشتراک اپلیکیشن',
      body: 'این اشتراک تا {expiredDate} قابل دسترسی است و در تمدید این اشتراک به اپ اضافه نمیشود. آیا از لغو اشتراک اطمینان دارید؟',
      refundPriceBody: '{price} به کیف پول شما عودت داده میشود. در صورت لغو اشتراک در همین لحظه غیرفعال میشود. آیا از لغو کردن اشتراک اطمینان دارید؟',
    },
    deleteAddon: {
      title: 'تاییدیه لغو افزودنی اشتراک',
      body: 'این افزودنی تا {expiredDate} قابل دسترسی است و در تمدید این ادان به اپ اضافه نمیشود. آیا از لغو افزودنی اشتراک اطمینان دارید؟',
      refundPriceBody: '{price} به کیف پول شما عودت داده میشود. در صورت لغو افزودنی در همین لحظه غیرفعال میشود. آیا از لغو کردن افزودنی اشتراک اطمینان دارید؟',
    }
  },

  confirmChanges: {
    labels: {
      addedAddons: 'جدید',
      removedAddons: 'حذف شده',
      refund: 'مرجوع شده',
      finalPrice: 'قیمت',
      difference: 'مابه التفاوت'
    },
    upgrade: {
      title: 'با ارتقاء دادن برخی از ویژگی ها فعال میشود'
    },
    downgrade: {
      title: 'با تنزل دادن برخی از ویژگی ها غیرفعال میشود'
    },
    descriptions: {
      hasCredit: 'با توجه به اینکه اشتراک فعلی شما به مبلغ {credit} اعتبار دارد، برای فعال‌سازی اشتراک جدید نیاز به پرداخت مبلغ {difference} می‌باشد.',
      noCredit: 'جهت فعال‌سازی تغییرات، لطفاً مبلغ {difference} پرداخت نمایید.',
      notNeedPay: 'با توجه به اینکه اشتراک فعلی شما به مبلغ {difference} اعتبار دارد، جهت فعال‌سازی اشتراک نیازی به پرداخت وجه نیست.'
    }
  },

  list: {
    title: 'اشتراک ها'
  },

  insert: {
    title: 'افزودن اشتراک'
  },

  edit: {
    title: 'ویرایش اشتراک'
  },

  subscription: {
    title: 'اشتراک اپلیکیشن',

    labels: {
      planPreName: 'اپلیکیشن',
      addonPreName: 'افزودنی'
    },

    table: {
      header: {
        row: 'ردیف',
        type: 'نوع',
        name: 'پلن / افزودنی',
        title: 'عنوان',
        expiredAt: 'تایخ انقضاء',
        renewStatus: 'وضعیت تمدید',
        price: 'قیمت',
        action: 'اکشن',
        delete: 'حذف'
      }
    },

    renewStatusTypes: {
      active: 'تمدید فعال',
      disable: 'تمدید غیرفعال'
    }
  }
}
